import { render, staticRenderFns } from "./CustomFields.vue?vue&type=template&id=0b2383c6&scoped=true"
import script from "./CustomFields.vue?vue&type=script&lang=js"
export * from "./CustomFields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b2383c6",
  null
  
)

export default component.exports